import type { PermissionTagsProps } from "./types-permission-tags";
import { PermissionTagsView } from "./view-permission-tags";

/** Permissões do perfil em tags (listagem e resumo dos pop-ups); sem lógica, a View recebe as props. */
export function PermissionTags(props: PermissionTagsProps) {
  return <PermissionTagsView {...props} />;
}

export type * from "./types-permission-tags";
